var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon === 0)?_c('span',{class:['right-arrow', _vm.classSpan]}):_c('span',{staticClass:"right-arrow right-arrow_base"},[_vm._v("→")])}
var staticRenderFns = []

export { render, staticRenderFns }